import React from "react";
import { motion } from "motion/react";
import "./css/drawings.css";
import DivisorDown from "../../components/divisorDown/divisorDown";
import Gallery from "../../components/galery/gallery";
import imagesData from "./json/drawings.json";
import othersData from "./json/others.json";
import CarruselDrawings from "../../components/carruselDrawings/carruselDrawings";

const Drawings = () => {
  return (
    <motion.div
      key={"empty"}
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="col-md-12 d-flex justify-content-center ">
        <div className="color-text-sofia-40-hv">Pencil Drawings</div>
      </div>

      <div className="margin-divisor-hv mb-1">
        <DivisorDown
          title="A collection of Pencil Drawings"
          subtitle="Studies and preliminary sketches including: Nudes, still life, portraits and more.
          These drawings are selected based on: dates, quality and context."
        />
      </div>

      <CarruselDrawings paintings={imagesData}/>

      <div className="margin-divisor-hv mb-5 mt-5">
        <DivisorDown
          supremeTitle="Mixed Media Drawings "
          title="A collection of Mixed media drawings "
          subtitle="A space where observation meets experimentation. Pencil, colors, sepia, sanguine and charcoal are some of the media used.
          These drawings are part of an ongoing process of exploration and discovery."
        />
      </div>

      <div className="margin-botton-gallery-hv">
        <Gallery images={othersData} />
      </div>
    </motion.div>
  );
};

export default Drawings;
